import {
  GET_PAYMENTS,
  GET_PAYMENTS_ERROR,
  GET_PAYMENTS_SUCCESS,
  GET_PAYMENTS_LOADING,
  GET_PAYMENTS_ROWS_PER_PAGE,
  GET_PAYMENTS_PAGE_NUMBER,
  GET_MORE_PAYMENTS,
  GET_MORE_PAYMENTS_LOADING,
} from "constants/ActionTypes";


export const getPayments = () => {
  return {
    type: GET_PAYMENTS,
  };
};

export const getMorePayments = (lastDocument) => {
  return {
    type: GET_MORE_PAYMENTS,
    payload: {
      lastDocument,
    }
  };
};

export const getPaymentsLoading = (value) => {
  return {
    type: GET_PAYMENTS_LOADING,
    payload: value,
  };
};

export const getMorePaymentsLoading = (value) => {
  return {
    type: GET_MORE_PAYMENTS_LOADING,
    payload: value,
  };
};

export const getPaymentsError = (error) => {
  return {
    type: GET_PAYMENTS_ERROR,
    payload: error,
  };
};

export const getPaymentsSuccess = (paymentsList, lastDocument) => {
  return {
    type: GET_PAYMENTS_SUCCESS,
    payload: {
      paymentsList,
      lastDocument,
    },
  };
};

export const setRowsPerPage = (value) => {
  return {
    type: GET_PAYMENTS_ROWS_PER_PAGE,
    payload: value,
  };
};

export const setPageNumber = (value) => {
  return {
    type: GET_PAYMENTS_PAGE_NUMBER,
    payload: value,
  };
};
